// ブラウザに「このサイトのデータは消さないでほしい」と頼む(Storage API の persist)。
// 端末の空き容量が少なくなったとき、ブラウザは通常のサイトのデータ(localStorage の Cognito セッションを含む)を
// 自動で削除することがある。永続化が認められたサイトはその対象から外れる。
// 認められるかはブラウザの判断(Chrome はサイトの利用実績やブックマーク等で自動判定、Safari は非対応)で、
// 失敗しても何もしない。
export const requestPersistentStorage = async (nav) => {
  const target =
    nav || (typeof navigator !== 'undefined' ? navigator : undefined)
  if (
    !target ||
    !target.storage ||
    typeof target.storage.persist !== 'function'
  ) {
    return null
  }
  try {
    if (typeof target.storage.persisted === 'function') {
      const already = await target.storage.persisted()
      if (already) return true
    }
    return await target.storage.persist()
  } catch (error) {
    return null
  }
}

export default () => {
  requestPersistentStorage()
}
